export default "__VITE_ASSET__BHN_fp33__"